export const SalaImages = (sala) => {
    let images = []

    if(!sala){
        return images;
    }

    Object.keys(sala).map((key) => {
        if(
            key == "imagen_desc_1" ||
            key == "imagen_desc_2" ||
            key == "imagen_desc_3" ||
            key == "imagen_int_1" ||
            key == "imagen_int_2" ||
            key == "imagen_int_3"
        ){
            images.push(`https://www.antesala.com.ar/assets/img/salas/${sala[key]}`);
        }
    })

    return images
}